import types from './types'
import axios from 'axios'
import get from 'lodash/get'
import groupBy from 'lodash/groupBy'

export default {
  namespaced: true,
  state: {
    status: void 0,
    item: null,
    historyStatus: void 0,
    historyItems: { items: null }
  },
  actions: {
    async getItem ({ commit }, { questionnaireId, teamId, memberId }) {
      commit(types.GET_LAST_QUERY.REQUEST)
      try {
        commit(types.GET_LAST_QUERY.SUCCESS, await axios.get(`/api/myTeam/questionnaires/${questionnaireId}/team/${teamId}/user/${memberId}`))
      } catch (err) {
        commit(types.GET_LAST_QUERY.FAILURE)
      }
    },
    async getHistory ({ commit }, { questionnaireId, teamId, memberId }) {
      commit(types.GET_HISTORY.REQUEST)
      try {
        commit(types.GET_HISTORY.SUCCESS, await axios.get(`/api/myTeam/questionnaires/${questionnaireId}/team/${teamId}/user/${memberId}/history`))
      } catch (err) {
        commit(types.GET_HISTORY.FAILURE)
      }
    }
  },
  mutations: {
    [types.GET_LAST_QUERY.REQUEST] (state) {
      state.status = 'fetching'
    },
    [types.GET_LAST_QUERY.SUCCESS] (state, result) {
      state.item = result.data
      state.status = 'success'
    },
    [types.GET_LAST_QUERY.FAILURE] (state) {
      state.status = 'error'
    },
    [types.GET_HISTORY.REQUEST] (state) {
      state.historyStatus = 'fetching'
    },
    [types.GET_HISTORY.SUCCESS] (state, result) {
      state.historyStatus = 'success'

      for (let i = 0; i < result.data.items.length; ++i) {
        const questions = get(result.data.items[i], 'query.questionnaireObj.questions')
        if (questions) {
          const answers = new Map(result.data.items[i].answers.map(({ question, answer }) => ([question, answer])))
          const alerts = new Map(result.data.items[i].answers.map(({ question, alertActive }) => ([question, alertActive])))
          questions.map(question => Object.assign(question, { answer: answers.get(question._id), alertActive: alerts.get(question._id) }))

          result.data.items[i].summary = groupBy(questions, 'type')
        }
      }

      state.historyItems = result.data
    },
    [types.GET_HISTORY.FAILURE] (state) {
      state.historyStatus = 'error'
    }
  },
  getters: {
    getQuestionsGropedByType: state => () => {
      const item = state.item
      if (item) {
        const questions = get(item, 'query.questionnaireObj.questions')
        if (questions) {
          const answers = new Map(item.answers.map(({ question, answer }) => ([question, answer])))
          const alerts = new Map(item.answers.map(({ question, alertActive }) => ([question, alertActive])))
          questions.map(question => Object.assign(question, { answer: answers.get(question._id), alertActive: alerts.get(question._id) }))

          return groupBy(questions, 'type')
        }
      }
    }
  }
}
